
import MindElementContent from './MindElementContent.js';

// import mind.yushu.com.mindmap.utils.Colors;
import Colors from "../../../utils/Colors"
// import mind.yushu.com.mindmap.viewmodel.datatype.IconLayoutType;
import IconLayoutType from '../../datatype/IconLayoutType'


/**
 * ProjectName: MindMap
 * Created by tony on 2020/5/27
 * Copyright(c) 2020 mindyushu.com
 */

class RemarksElementContent extends MindElementContent {
    constructor(text = "",width,height,styleColor = Colors.white,tintColor = Colors.clear){
        super(width,height)
        this.text = text;
        this.styleColor = styleColor;
        this.tintColor = tintColor;
        this.layoutType = IconLayoutType.LAYOUT_LEFT;
        this.RemarksElementContent(text, width, height, styleColor, tintColor)
    }


    // public RemarksElementContent() {
    //     super();
    // }

    // public RemarksElementContent(String text, int width, int height) {
    //     this(text, width, height, Colors.white, Colors.clear);
    // }

    RemarksElementContent(text, width, height, styleColor, tintColor) {
        // super();
        this.text = text;
        this.width = width;
        this.height = height;
        this.styleColor = styleColor;
        this.tintColor = tintColor;
    }

    copy() {
        let data = new RemarksElementContent(this.text, this.width, this.height, this.styleColor, this.tintColor);
        data.x = this.x;
        data.y = this.y;
        data.layoutType = this.layoutType;
        return data;
    }

    equal(data, ignorePoint = false, ignoreSize = false) {
        let result = false;
        if (!ignorePoint) {
            result = result || data.x != this.x;
            result = result || data.y != this.y;
        }
        if (!ignoreSize) {
            result = result || data.width != this.width;
            result = result || data.height != this.height;
        }
        result = result || data.styleColor != this.styleColor;
        result = result || data.layoutType != this.layoutType;
        result = result || data.tintColor != this.tintColor;
        result = result || data.text != this.text;
        return !result;
    }
}
export default RemarksElementContent
